import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=4ae110c3&scoped=true"
import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=4ae110c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae110c3",
  null
  
)

export default component.exports